var React = require('react');

function IcFullscreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.3 3.7L0 6V0H6L3.7 2.3L6.59 5.17L5.17 6.59L2.3 3.7ZM14.3 2.3L12 0H18V6L15.7 3.7L12.83 6.59L11.41 5.17L14.3 2.3ZM6 18L3.7 15.7L6.59 12.83L5.17 11.41L2.3 14.3L0 12V18H6ZM15.7 14.3L18 12V18H12L14.3 15.7L11.41 12.83L12.83 11.41L15.7 14.3Z","fill":"currentColor"}));
}

IcFullscreen.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = IcFullscreen;

IcFullscreen.default = IcFullscreen;
